export default __webpack_public_path__ + "static/media/DashboardCustomers.342771db.svg";